import { BasketLineItemROV1 } from "@ub/basket-client"

import { formatPrice } from "@/lib/helper"
import { BasketData, DiscountType } from "@/lib/intershop/interfaces/basket/basket"
import {
  BasketLineItemData,
  BasketLineItemFormattedData,
  BasketLineItemValueData,
  BasketPromotionCode,
  BasketTotalData,
  DiscountData,
} from "@/lib/storefront/basket/basket"
import { ReducedProductData } from "@/lib/storefront/product/product"

function roundTo2(numberToRound: number) {
  return Math.round(numberToRound * 100) / 100
}

/*function floorTo2(numberToRound: number) {
  return Math.floor(numberToRound * 100) / 100
}*/

export function findLineItemForSku(basket: BasketData, sku?: string): BasketLineItemROV1 | null {
  if (basket.data?.lineItems && sku) {
    for (let lineItemId of basket.data?.lineItems) {
      if (basket.included?.lineItems) {
        const lineItem = basket.included?.lineItems[lineItemId]
        if (lineItem?.product === sku) {
          return lineItem
        }
      }
    }
  }
  return null
}

function extractDISCOUNT_TYPE_SPECIAL_VOUCHER(
  discountAttributeValue: string,
  existingLineItem: BasketLineItemROV1
): DiscountData {
  const discountType: DiscountType = "VOUCHER"
  let discountAmount: number = 0
  let discountPercent: number = 0

  const discountAttributeValueArray: string[] = discountAttributeValue.split(";")
  if (discountAttributeValueArray.length > 1) {
    discountPercent = Number.parseFloat(discountAttributeValueArray[1])
  }

  let appliedPromotionIDsValue: string | undefined
  let discountValue: string | undefined

  appliedPromotionIDsValue = existingLineItem["attributes"]?.find(
    (attributeValue) => attributeValue.name === "appliedPromotionIDs"
  )?.value as string
  if (appliedPromotionIDsValue) {
    discountValue = existingLineItem["attributes"]?.find(
      (attributeValue) => attributeValue.name === appliedPromotionIDsValue + "_discountValue"
    )?.value as string
  }
  if (discountValue) {
    const discountValueArray: string[] = discountValue.split(";")
    if (discountValueArray.length > 1) {
      discountAmount = Number.parseFloat(discountValueArray[1])
    }
  }
  return { discountType, discountPercent, discountAmount }
}

function extractDISCOUNT_TYPE_SPECIAL(
  discountAttributeValue: string,
  targetDiscountType: DiscountType,
  lineItem: BasketLineItemROV1 | null
): DiscountData {
  let discountAmount: number = 0
  let discountPercent: number = 0

  const discountAttributeValueArray: string[] = discountAttributeValue.split(";")
  if (discountAttributeValueArray.length > 1) {
    discountPercent = Number.parseFloat(discountAttributeValueArray[1])
  }

  const discountFactor = 1 - discountPercent / 100
  const reverseDiscountFactor = 1 / discountFactor

  if (lineItem?.pricing?.price?.net?.value) {
    discountAmount = lineItem?.pricing?.price?.net?.value * reverseDiscountFactor - lineItem?.pricing?.price?.net?.value
  }

  return { discountType: targetDiscountType, discountPercent, discountAmount }
}

export function determineDiscountDataFromLineItem(lineItem: BasketLineItemROV1 | null) {
  let discountAttributeValue: string | undefined
  let discountType: DiscountType = "SPECIAL"
  let discountAmount: number = 0.0
  let discountPercent: number = 0.0

  if (lineItem) {
    discountAttributeValue = lineItem["attributes"]?.find((attributeValue) => attributeValue.name === "UBPLIRebateRate")
      ?.value as string

    if (discountAttributeValue) {
      if (discountAttributeValue.startsWith("DISCOUNT_TYPE_CUSTOMER_GENERAL")) {
        const __ret = extractDISCOUNT_TYPE_SPECIAL(discountAttributeValue, "GENERAL", lineItem)
        discountType = __ret.discountType
        discountPercent = __ret.discountPercent
        discountAmount = __ret.discountAmount
      } else if (discountAttributeValue.startsWith("DISCOUNT_TYPE_SPECIAL_VOUCHER")) {
        const __ret = extractDISCOUNT_TYPE_SPECIAL_VOUCHER(discountAttributeValue, lineItem)
        discountType = __ret.discountType
        discountPercent = __ret.discountPercent
        discountAmount = __ret.discountAmount
      } else if (discountAttributeValue.startsWith("DISCOUNT_TYPE_CATEGORY_GENERAL")) {
        const __ret = extractDISCOUNT_TYPE_SPECIAL(discountAttributeValue, "CATEGORY", lineItem)
        discountType = __ret.discountType
        discountPercent = __ret.discountPercent
        discountAmount = __ret.discountAmount
      } else if (discountAttributeValue.startsWith("DISCOUNT_TYPE_SPECIAL_PRICELIST")) {
        const __ret = extractDISCOUNT_TYPE_SPECIAL(discountAttributeValue, "PRICELIST", lineItem)
        discountType = __ret.discountType
        discountPercent = __ret.discountPercent
        discountAmount = __ret.discountAmount
      } else if (discountAttributeValue.startsWith("DISCOUNT_TYPE_SPECIAL_PRICELIST")) {
        const __ret = extractDISCOUNT_TYPE_SPECIAL(discountAttributeValue, "PRICELIST", lineItem)
        discountType = __ret.discountType
        discountPercent = __ret.discountPercent
        discountAmount = __ret.discountAmount
      }
    }
  }

  const discountData: DiscountData = {
    discountType: discountType,
    discountAmount: discountAmount,
    discountPercent: discountPercent,
  }

  return discountData
}

function extractB2BLineItemData(product: ReducedProductData, lineItem: BasketLineItemROV1): BasketLineItemValueData {
  const discountData: DiscountData = determineDiscountDataFromLineItem(lineItem)
  console.dir(discountData)
  let singleSalePriceNet = lineItem?.pricing?.singleBasePrice?.net?.value
  let singleSalePriceGross = lineItem?.pricing?.singleBasePrice?.gross?.value
  let totalSalePriceNet = 0.0
  let totalSalePriceGross = 0.0

  if (discountData && discountData.discountType === "VOUCHER") {
    singleSalePriceNet =
      (lineItem?.pricing?.undiscountedSingleBasePrice?.net?.value ?? 0) -
      discountData.discountAmount / lineItem.quantity.value
    singleSalePriceGross = lineItem?.pricing?.undiscountedSingleBasePrice?.gross?.value ?? 0 //TODO - calc

    totalSalePriceNet = (lineItem?.pricing?.undiscountedPrice?.net?.value ?? 0) - discountData.discountAmount
    totalSalePriceGross = lineItem?.pricing?.undiscountedPrice?.gross?.value ?? 0 // TODO - calc
  } else {
    singleSalePriceNet = lineItem?.pricing?.singleBasePrice?.net?.value ?? 0
    singleSalePriceGross = lineItem?.pricing?.singleBasePrice?.gross?.value ?? 0

    totalSalePriceNet = lineItem?.pricing?.price?.net?.value ?? 0
    totalSalePriceGross = lineItem?.pricing?.price?.gross?.value ?? 0
  }

  //const discountAmount = (totalSalePrice && totalListPrice && (totalSalePrice < totalListPrice)) ? -1 * (totalListPrice - totalSalePrice) : 0
  const discountAmount = discountData.discountAmount
  //const discountPercent: number = (totalSalePrice && totalListPrice) ? (totalSalePrice > 0 && totalListPrice > 0 ? Math.round(100 - (totalSalePrice / totalListPrice) * 100) : 0) : 0
  const discountPercent: number = discountData.discountPercent

  const discountFactor = 1 - discountPercent / 100

  const isDiscounted = !(discountAmount < 0.001)

  const ecoTax = product?.ecoTax

  //const singleListPriceNet = lineItem?.pricing?.undiscountedSingleBasePrice?.net?.value // Wrong in raw data
  //const singleListPriceGross = lineItem?.pricing?.undiscountedSingleBasePrice?.gross?.value // Wrong in raw data

  const singleListPriceGross = (singleSalePriceGross ?? 0) / discountFactor
  const singleListPriceNet = (singleSalePriceNet ?? 0) / discountFactor

  const totalListPriceNet = singleListPriceNet * lineItem.quantity.value
  const totalListPriceGross = singleListPriceGross * lineItem.quantity.value

  return {
    originalProduct: product,
    originalLineItem: lineItem,
    discountType: discountData.discountType,
    discountPercent: discountData.discountPercent,
    discountAmount: discountData.discountAmount,
    id: lineItem.id,
    position: lineItem.position ?? 1,
    product: product,
    quantity: lineItem.quantity.value,
    ecoTax: ecoTax,
    singleSalePriceNet: singleSalePriceNet,
    singleSalePriceGross: singleSalePriceGross,
    singleListPriceNet: singleListPriceNet,
    singleListPriceGross: singleListPriceGross,
    totalSalePriceNet: totalSalePriceNet,
    totalSalePriceGross: totalSalePriceGross,
    totalListPriceNet: totalListPriceNet,
    totalListPriceGross: totalListPriceGross,
    isDiscounted: isDiscounted,
  }
}

function extractB2CLineItemData(product: ReducedProductData, lineItem: BasketLineItemROV1) {
  const discountData: DiscountData = determineDiscountDataFromLineItem(lineItem)
  //const discountAmount = (totalSalePrice && totalListPrice && (totalSalePrice < totalListPrice)) ? -1 * (totalListPrice - totalSalePrice) : 0
  const discountAmount = discountData.discountAmount
  //const discountPercent: number = (totalSalePrice && totalListPrice) ? (totalSalePrice > 0 && totalListPrice > 0 ? Math.round(100 - (totalSalePrice / totalListPrice) * 100) : 0) : 0
  const discountPercent: number = discountData.discountPercent
  const discountFactor = 1 - discountPercent / 100
  const isDiscounted = !(discountAmount < 0.001)

  let singleSalePriceNet = lineItem?.pricing?.singleBasePrice?.net?.value
  let singleSalePriceGross = lineItem?.pricing?.singleBasePrice?.gross?.value
  let totalSalePriceNet = 0.0
  let totalSalePriceGross = 0.0

  const effectiveTaxFactor = roundTo2(
    (lineItem?.pricing?.price?.gross?.value ?? 0) / (lineItem?.pricing?.price?.net?.value ?? 0)
  )

  if (discountData && discountData.discountType === "VOUCHER") {
    singleSalePriceNet =
      (lineItem?.pricing?.undiscountedPrice?.net?.value ?? 0) / lineItem.quantity.value -
      discountData.discountAmount / lineItem.quantity.value
    singleSalePriceGross = singleSalePriceNet * effectiveTaxFactor

    totalSalePriceNet = singleSalePriceNet * lineItem.quantity.value

    totalSalePriceGross = roundTo2(singleSalePriceGross * lineItem.quantity.value) //Why floor here is not clear - otherwise line item calc != basket total
  } else {
    totalSalePriceNet = lineItem?.pricing?.price?.net?.value ?? 0
    totalSalePriceGross = lineItem?.pricing?.price?.gross?.value ?? 0
  }

  singleSalePriceNet = totalSalePriceNet / lineItem.quantity.value
  singleSalePriceGross = totalSalePriceGross / lineItem.quantity.value

  const ecoTax = product?.ecoTax

  //const singleListPriceNet = lineItem?.pricing?.undiscountedSingleBasePrice?.net?.value // Wrong in raw data
  //const singleListPriceGross = lineItem?.pricing?.undiscountedSingleBasePrice?.gross?.value // Wrong in raw data

  const singleListPriceNet = product.listPrice ?? 0
  const singleListPriceGross = Math.round(singleListPriceNet * effectiveTaxFactor * 100) / 100

  const totalListPriceNet = singleListPriceNet * lineItem.quantity.value
  const totalListPriceGross = singleListPriceGross * lineItem.quantity.value

  return {
    originalProduct: product,
    originalLineItem: lineItem,
    discountType: discountData.discountType,
    discountPercent: discountData.discountPercent,
    discountAmount: discountData.discountAmount,
    id: lineItem.id,
    position: lineItem.position ?? 1,
    product: product,
    quantity: lineItem.quantity.value,
    ecoTax: ecoTax,
    singleSalePriceNet: singleSalePriceNet,
    singleSalePriceGross: singleSalePriceGross,
    singleListPriceNet: singleListPriceNet,
    singleListPriceGross: singleListPriceGross,
    totalSalePriceNet: totalSalePriceNet,
    totalSalePriceGross: totalSalePriceGross,
    totalListPriceNet: totalListPriceNet,
    totalListPriceGross: totalListPriceGross,
    isDiscounted: isDiscounted,
  }
}

export function createBasketLineItem(
  isoLocale: string,
  isB2B: boolean,
  product: ReducedProductData,
  lineItem: BasketLineItemROV1
): BasketLineItemData {
  const basketLineItemsValueData = isB2B
    ? extractB2BLineItemData(product, lineItem)
    : extractB2CLineItemData(product, lineItem)

  return {
    ...basketLineItemsValueData,
    ...createFormattedValues(isoLocale, isB2B, product.currency, basketLineItemsValueData),
  }
}

function determineBasketTotalDataB2B(
  basketData: BasketData | undefined,
  basketLineItems: BasketLineItemData[] | undefined,
  basketPromotionCodes: BasketPromotionCode[] | undefined
  /*isAnonymous: boolean*/
) {
  const effectiveTaxRate = basketData?.data?.totals?.taxTotalsByTaxRate?.[0]?.effectiveTaxRate ?? 1
  //const listItemTotalNet = basketData?.data?.totals?.itemTotal?.net?.value ?? 0
  const listItemTotalGross = basketData?.data?.totals?.itemTotal?.gross?.value ?? 0
  const discountedItemTotalNet = basketData?.data?.totals?.grandTotal?.net?.value ?? 0
  const discountedItemTotalGross = basketData?.data?.totals?.grandTotal?.gross?.value ?? 0

  const totalTax = basketData?.data?.totals?.grandTotal?.tax?.value ?? 0
  const valueDiscountsTotalNet = basketData?.data?.totals?.valueDiscountsTotal?.net?.value ?? 0 //Voucher in B2B case
  const valueDiscountsTotalGross = basketData?.data?.totals?.valueDiscountsTotal?.gross?.value ?? 0 //Voucher in B2B case
  const shippingTotalNet = basketData?.data?.totals?.shippingTotal?.net?.value ?? 0

  const currency: string = basketData?.data?.totals?.grandTotal?.net?.currency ?? "EUR"

  const taxFactor =
    /* (isB2B || !effectiveTaxRate) ?Math.round((totalTax / grandTotalNet + 1) * 100) / 100:*/ effectiveTaxRate / 100 +
    1

  //let itemTotalNet = 0
  //let itemTotalGross = 0
  let listItemTotalNet = 0
  let totalSavingsNet = 0
  let totalSavingsGeneralNet = 0.0
  let totalSavingsSpecialNet: number = 0.0
  let totalSavingsPriceListNet: number = 0.0
  const paymentCostAmountGross = 0.0
  const noPaymentCostDifference = 0

  if (basketLineItems) {
    basketLineItems.forEach(function (singleLineItem) {
      totalSavingsNet += singleLineItem.discountAmount
      if (singleLineItem.discountType === "GENERAL") {
        totalSavingsGeneralNet += singleLineItem.discountAmount
      }
      if (singleLineItem.discountType === "SPECIAL" || singleLineItem.discountType === "CATEGORY") {
        totalSavingsSpecialNet += singleLineItem.discountAmount
      }
      if (singleLineItem.discountType === "PRICELIST") {
        totalSavingsPriceListNet += singleLineItem.discountAmount
      }

      //itemTotalNet += singleLineItem.totalListPriceNet ?? 0
      //itemTotalGross += singleLineItem.totalListPriceGross ?? 0
    })
  }

  listItemTotalNet = totalSavingsNet + discountedItemTotalNet

  //itemTotalGross = itemTotalNet * taxFactor
  //itemTotalNet = basketData?.data?.totals?.undiscountedItemTotal?.net?.value ?? 0
  //itemTotalGross = basketData?.data?.totals?.undiscountedItemTotal?.gross?.value ?? 0

  const grandTotalNet = discountedItemTotalNet
  let grandTotalGross = discountedItemTotalGross //discountedItemTotalNet * taxFactor

  //const grandTotalNet = basketData?.data?.totals?.undiscountedItemTotal?.net?.value??0
  //const grandTotalGross = (basketData?.data?.totals?.undiscountedItemTotal?.gross?.value??0) + paymentCostAmountGross

  //console.info("grandTotalNet: " + grandTotalNet)

  let promotionCode: string | undefined
  let promotionAmountNet: number = 0
  let promotionAmountGross: number = 0
  if (basketPromotionCodes && basketPromotionCodes.length > 0) {
    promotionCode = basketPromotionCodes[0].code
    promotionAmountNet = -1 * valueDiscountsTotalNet
    promotionAmountGross = -1 * valueDiscountsTotalGross
  }

  const hasDiscounts =
    totalSavingsSpecialNet !== 0 ||
    totalSavingsPriceListNet !== 0 ||
    totalSavingsGeneralNet !== 0 ||
    promotionAmountNet !== 0

  return {
    paymentCostAmountGross: paymentCostAmountGross,
    taxFactor: taxFactor,
    totalProductQuantity: basketData?.data?.totalProductQuantity ?? 0,
    discountedItemTotalNet: discountedItemTotalNet,
    discountedItemTotalGross: grandTotalGross - paymentCostAmountGross,
    listItemTotalNet: listItemTotalNet,
    listItemTotalGross: listItemTotalGross,
    hasDiscounts: hasDiscounts,
    grandTotalNet: grandTotalNet,
    grandTotalGross: grandTotalGross,
    shippingTotalNet: shippingTotalNet,
    ecoTaxTotal: basketData?.ecoTaxTotal ?? 0,
    totalSavingsNet: totalSavingsNet + promotionAmountNet,
    totalSavingsGross: discountedItemTotalGross - listItemTotalGross,
    totalSavingsGeneralNet: totalSavingsGeneralNet,
    totalSavingsPriceListNet: totalSavingsPriceListNet,
    totalSavingsSpecialNet: totalSavingsSpecialNet,
    promotionAmountNet: promotionAmountNet,
    promotionAmountGross: promotionAmountGross,
    noPaymentCostDifference: noPaymentCostDifference,
    totalTax: totalTax,
    effectiveTaxRate: effectiveTaxRate,
    promotionCode: promotionCode,
    currency: currency,
  }
}

interface HandlingFeeData {
  fee: number
  threshold: number
}

function resolveHandlingFeeData(isoLocale: string): HandlingFeeData {
  if (isoLocale === "de-DE" || isoLocale === "de-AT") {
    return { fee: 9.9, threshold: 50 }
  } else if (isoLocale === "de-CH" || isoLocale === "fr-CH") {
    return { fee: 15, threshold: 75 }
  }

  return { fee: 0, threshold: 0 }
}

function determineBasketTotalDataB2C(
  basketData: BasketData | undefined,
  basketLineItems: BasketLineItemData[] | undefined,
  basketPromotionCodes: BasketPromotionCode[] | undefined,
  isAnonymous: boolean,
  isoLocale: string
) {
  const effectiveTaxRate = basketData?.data?.totals?.taxTotalsByTaxRate?.[0]?.effectiveTaxRate ?? 1

  let valueDiscountsTotalNet = 0 //In B2C Case voucher savings had to be extracted from line items as it is missing basket calculation
  let valueDiscountsTotalGross = 0
  const shippingTotalNet = basketData?.data?.totals?.shippingTotal?.net?.value ?? 0

  const currency: string = basketData?.data?.totals?.grandTotal?.net?.currency ?? "EUR"

  const taxFactor = effectiveTaxRate / 100 + 1

  let grandTotalNet = 0
  let grandTotalGross = 0
  let discountedItemTotalNet = 0
  let discountedItemTotalGross = 0
  let listItemTotalNet = 0
  let listItemTotalGross = 0
  let totalSavingsNet = 0
  let totalSavingsGeneralNet = 0.0
  let totalSavingsSpecialNet: number = 0.0
  let totalSavingsPriceListNet: number = 0.0
  let paymentCostAmountGross = 0.0

  /* /!* if (isAnonymous) {*!/
  const tempGrandTotalGross = basketData?.data?.totals?.grandTotal?.gross?.value ?? 0
  const tempItemTotalGross = basketData?.data?.totals?.itemTotal?.gross?.value ?? 0

  if (tempGrandTotalGross > tempItemTotalGross) {
    discountedItemTotalNet = basketData?.data?.totals?.itemTotal?.net?.value ?? 0
    discountedItemTotalGross = basketData?.data?.totals?.itemTotal?.gross?.value ?? 0
  } else {
    discountedItemTotalNet = basketData?.data?.totals?.grandTotal?.net?.value ?? 0
    discountedItemTotalGross = basketData?.data?.totals?.grandTotal?.gross?.value ?? 0
  }*/

  discountedItemTotalNet = basketData?.data?.totals?.itemTotal?.net?.value ?? 0
  discountedItemTotalGross = basketData?.data?.totals?.itemTotal?.gross?.value ?? 0

  if (basketLineItems) {
    basketLineItems.forEach(function (singleLineItem) {
      totalSavingsNet += singleLineItem.discountAmount
      if (singleLineItem.discountType === "GENERAL") {
        totalSavingsGeneralNet += singleLineItem.discountAmount
      }
      if (singleLineItem.discountType === "SPECIAL" || singleLineItem.discountType === "CATEGORY") {
        totalSavingsSpecialNet += singleLineItem.discountAmount
      }
      if (singleLineItem.discountType === "PRICELIST") {
        totalSavingsPriceListNet += singleLineItem.discountAmount
      }
      if (singleLineItem.discountType === "VOUCHER") {
        valueDiscountsTotalNet += singleLineItem.discountAmount
      }

      listItemTotalNet += singleLineItem.totalListPriceNet ?? 0
      //itemTotalGross += singleLineItem.totalListPriceGross ?? 0
    })
  }

  /*
  console.log("totalSavingsNet: " + totalSavingsNet)
*/

  /*Fixes scale prices*/
  if (listItemTotalNet > (basketData?.data?.totals?.undiscountedItemTotal?.net?.value ?? 0)) {
    // listItemTotalNet = basketData?.data?.totals?.undiscountedItemTotal?.net?.value ?? 0
    /*ToDo - Needed anymore?*/
  }

  listItemTotalGross = basketData?.data?.totals?.itemTotal?.gross?.value ?? listItemTotalNet * taxFactor

  /*totalLineItemTax could be read from grandTotal?.tax?.value OR taxTotalsByTaxRate[0].calculatedTax.value OR salesTaxTotalsByTaxRate[0].calculatedTax.value
   * Seems the last one that exists is correct (Need to be checked)
   * */
  let totalLineItemTax: number = basketData?.data?.totals?.grandTotal?.tax?.value ?? 0

  if (basketData?.data?.totals?.taxTotalsByTaxRate && basketData?.data?.totals?.taxTotalsByTaxRate.length > 0) {
    totalLineItemTax = basketData?.data?.totals?.taxTotalsByTaxRate[0].calculatedTax.value ?? 0
  }

  if (
    basketData?.data?.totals?.salesTaxTotalsByTaxRate &&
    basketData?.data?.totals?.salesTaxTotalsByTaxRate.length > 0
  ) {
    totalLineItemTax = basketData?.data?.totals?.salesTaxTotalsByTaxRate[0].calculatedTax.value ?? 0
  }

  const totalTax = totalLineItemTax - (basketData?.data?.totals?.paymentCostsTotal?.tax?.value ?? 0) //- Tax der Abwicklungspauschale
  if (isAnonymous) {
    grandTotalNet = basketData?.data?.totals?.itemTotal?.net?.value ?? 0
    grandTotalGross = (basketData?.data?.totals?.itemTotal?.gross?.value ?? 0) + paymentCostAmountGross
  } else {
    //grandTotalNet = basketData?.data?.totals?.grandTotal?.net?.value ?? 0
    //grandTotalGross = basketData?.data?.totals?.grandTotal?.gross?.value ?? 0
    grandTotalNet = basketData?.data?.totals?.itemTotal?.net?.value ?? 0
    grandTotalGross = (basketData?.data?.totals?.itemTotal?.gross?.value ?? 0) + paymentCostAmountGross
  }

  //paymentCostAmountGross = (basketData?.data?.totals?.paymentCostsTotal?.net?.value ?? 0) * taxFactor
  if (isAnonymous) {
    const handlingFeeData = resolveHandlingFeeData(isoLocale)
    if (grandTotalGross < handlingFeeData.threshold) {
      paymentCostAmountGross = handlingFeeData.fee
    }
    grandTotalGross = discountedItemTotalGross + paymentCostAmountGross
  } else {
    paymentCostAmountGross =
      ((basketData?.data?.totals?.paymentCostsTotal?.tax?.value ?? 0) / effectiveTaxRate) * 100 +
      (basketData?.data?.totals?.paymentCostsTotal?.tax?.value ?? 0)
  }

  let promotionCode: string | undefined
  let promotionAmountNet: number = 0
  let promotionAmountGross: number = 0
  if (basketPromotionCodes && basketPromotionCodes.length > 0) {
    promotionCode = basketPromotionCodes[0].code
    promotionAmountNet = -1 * valueDiscountsTotalNet
    promotionAmountGross = -1 * valueDiscountsTotalGross
  }

  let fullTotalSavingsNet = -1 * totalSavingsNet //possibly wrong
  let fullTotalSavingsGross = fullTotalSavingsNet * taxFactor /*discountedItemTotalGross - listItemTotalGross*/

  let noPaymentCostDifference = 0

  noPaymentCostDifference = resolveHandlingFeeData(isoLocale).threshold - grandTotalGross + paymentCostAmountGross

  //console.log(totalSavingsNet)
  if (fullTotalSavingsNet < 0 && discountedItemTotalNet === listItemTotalNet) {
    discountedItemTotalNet = listItemTotalNet - fullTotalSavingsNet
  }

  return {
    paymentCostAmountGross: paymentCostAmountGross,
    taxFactor: taxFactor,
    totalProductQuantity: basketData?.data?.totalProductQuantity ?? 0,
    discountedItemTotalNet: discountedItemTotalNet,
    discountedItemTotalGross: discountedItemTotalGross,
    listItemTotalNet: listItemTotalNet,
    listItemTotalGross: listItemTotalGross,
    hasDiscounts:
      totalSavingsSpecialNet !== 0 ||
      totalSavingsPriceListNet !== 0 ||
      totalSavingsGeneralNet !== 0 ||
      promotionAmountNet !== 0,
    grandTotalNet: grandTotalNet,
    grandTotalGross: grandTotalGross,
    shippingTotalNet: shippingTotalNet,
    ecoTaxTotal: basketData?.ecoTaxTotal ?? 0,
    totalSavingsNet: fullTotalSavingsNet,
    totalSavingsGross: fullTotalSavingsGross,
    totalSavingsGeneralNet: totalSavingsGeneralNet,
    totalSavingsPriceListNet: totalSavingsPriceListNet,
    totalSavingsSpecialNet: totalSavingsSpecialNet,
    promotionAmountNet: promotionAmountNet,
    promotionAmountGross: promotionAmountGross,
    noPaymentCostDifference: noPaymentCostDifference,
    totalTax: totalTax,
    effectiveTaxRate: effectiveTaxRate,
    promotionCode: promotionCode,
    currency: currency,
  }
}

export function determineBasketTotalData(
  isB2B: boolean,
  basketData?: BasketData,
  basketLineItems?: BasketLineItemData[],
  basketPromotionCodes?: BasketPromotionCode[],
  isAnonymous?: boolean,
  isoLocale?: string
): BasketTotalData {
  if (isB2B) {
    return determineBasketTotalDataB2B(basketData, basketLineItems, basketPromotionCodes /*, isAnonymous ?? true*/)
  } else {
    return determineBasketTotalDataB2C(
      basketData,
      basketLineItems,
      basketPromotionCodes,
      isAnonymous ?? true,
      isoLocale ?? "de"
    )
  }
}

function createFormattedValues(
  isoLocale: string,
  isB2B: boolean,
  currency: string,
  basketLineItemValueData: BasketLineItemValueData
): BasketLineItemFormattedData {
  return {
    salePriceFormatted: formatPrice(
      isoLocale,
      isB2B ? basketLineItemValueData.singleSalePriceNet : basketLineItemValueData.singleSalePriceGross,
      currency
    ),
    listPriceFormatted: formatPrice(
      isoLocale,
      isB2B ? basketLineItemValueData.singleListPriceNet : basketLineItemValueData.singleListPriceGross,
      currency
    ),
    ecoTaxFormatted: formatPrice(isoLocale, basketLineItemValueData.ecoTax, currency),
    totalSalePriceFormatted: formatPrice(
      isoLocale,
      isB2B ? basketLineItemValueData.totalSalePriceNet : basketLineItemValueData.totalSalePriceGross,
      currency
    ),
    totalListPriceFormatted: formatPrice(
      isoLocale,
      isB2B ? basketLineItemValueData.totalListPriceNet : basketLineItemValueData.totalListPriceGross,
      currency
    ),
    discountPercentFormatted: Math.floor(basketLineItemValueData.discountPercent) + "%", //https://udobaer.atlassian.net/browse/UBW-758,
    discountAmountFormatted: formatPrice(isoLocale, -1 * basketLineItemValueData.discountAmount, currency),
  }
}
